import classNames from 'classnames';
import { FC } from 'react';
import SbEditable from 'storyblok-react';

import { Image } from '../Image';
import { InlineVideo } from '../InlineVideo/InlineVideo';
import PageSection from '../Layout/PageSection/PageSection';
import { TextGroup } from '../TextGroup/TextGroup';

interface Props {
  reorder: boolean;
  sections: Array<InlineVideoBlok | ImageBlok | TextGroupBlok>;
}

export const StaticHero: FC<Props> = ({ reorder = false, sections }) => {
  const component = (blok: Props['sections'][0]) => {
    switch (blok.component) {
      case 'inlineVideo': {
        const video = blok as InlineVideoBlok;
        return (
          <InlineVideo
            autoplay={video.autoplay}
            cover={video.cover.filename}
            platform={video.platform}
            playButton={video.playButton}
            ratio={video.ratio}
            requiresAuthToPlay={video.requiresAuthToPlay}
            title={video.alt || video.cover.alt}
            videoId={video.videoId}
          />
        );
      }
      case 'image': {
        return (
          <Image
            alt={blok.image.alt}
            className="overflow-hidden rounded-sm"
            eagerLoading
            size={{
              sm: { ratio: '4/3', span: 12 },
              md: { ratio: '9/4', span: 12 },
              lg: { ratio: '9/4', span: 12 },
            }}
            src={blok.image.filename}
          />
        );
      }
      case 'textGroup':
        return <TextGroup {...(blok as TextGroupBlok)} mainTitle />;
      default:
        return null;
    }
  };

  return (
    <PageSection>
      <div
        className={classNames('flex gap-9 md:gap-12', {
          'flex-col': !reorder,
          'flex-col-reverse md:flex-col': reorder,
        })}
      >
        {sections.map((blok) => (
          // @ts-expect-error require storyblok-react upgrade
          <SbEditable key={blok._uid} content={blok}>
            {component(blok)}
          </SbEditable>
        ))}
      </div>
    </PageSection>
  );
};
